import axios from 'axios';
import AppConfig from '../../AppConfig';
import { axiosBaseConfig, setupInterceptors } from './baseAxiosInstance';

const employeeExperienceV3AxiosInstance = axios.create({
  ...axiosBaseConfig,
  baseURL: AppConfig.EMPLOYEE_EXPERIENCE_V3_BASE_URL as string,
});

setupInterceptors(employeeExperienceV3AxiosInstance);

export default employeeExperienceV3AxiosInstance;
